<template>
    <div class='summary-container' v-show='product.product'>
       <div class="product-summary-container"> 
            <div class='product-details'> 
                <div v-show='product.product' class='product-title'>{{product.product}}</div>
                <div class='sub-info-container'>
                    <div>
                        <div class="product-sku">
                            <div v-if="product.typeid != 4 && product.typeid != 8">Case Size: 6</div>
                        </div>
                        <div class='price-container'>
                            <div class='price'>£{{product.price}} excl. VAT</div>
                        </div>
                        <div class='online-only-text'>
                            {{product.b2b_online_only}}
                        </div>
                    </div>
                    <div class='splodge-container'>
                        <div class="product-availability-container">
                            <div class="availability-status" :class="product.availability_color">
                                <div class='status-text' v-if="product.availability_color == 'black'">AVAILABLE<br><span class="availability-days">2-3 DAYS</span></div>
                                <div class='status-text' v-if="product.availability_color == 'green'">AVAILABLE<br><span class="availability-days">NOW</span></div>
                                <div class='status-text' v-if="product.availability_color == 'red'">NOT CURRENTLY AVAILABLE</div>
                            </div>
                        </div>
                        <OnlineOnlyBadge :tooltip='product.b2b_online_only' :large='true'/>
                    </div>
                </div>
            </div>
       </div>
        <div class='summary-separator'></div>
    </div>
</template>

<script>
import OnlineOnlyBadge from '@/ecom/components/products/OnlineOnlyBadge.vue';

export default {
    components:{OnlineOnlyBadge},
    props: ['product']
}
</script>

<style lang="scss" scoped>
.summary-container{
    display: flex;
    flex-direction: column;
    gap: 15px;
    flex-grow: 1;
}
.product-summary-container{
    // display: flex;
    // gap: 80px;
    // justify-content: space-between;

    @media(max-width: 1200px){
        flex-direction: column;
        gap: 24px;
    }
}
.product-details{
    display: flex;
    flex-direction: column;
    gap: 15px;
}
.product-title{
    font-size: 1.4rem;
    font-weight: 600;
    line-height: 40px;
    color: var(--black);
}

.price-container{
    display: flex;
    gap: 15px;
    align-items: center;
    margin-top: 12px;
}

.price{
    font-size: 1.18rem;
    font-weight: 600;
}

.sub-info-container{
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.price-slashed{
    font-size: 1.39rem;
    font-weight: 600;
    line-height: 40px;
    color: var(--black);
}
.price-slashed span{
    border-bottom: 1px dashed #283533;
}

.ratings-container{
    cursor: pointer;
}

.details{
    // max-width: 500px;
}

.favourite{
    font-size: 1.2rem;
    color: #fa5252;
}

.product-code{
    color: #737373;

}
.summary-separator{
    border: 1px solid #B9B3AE;
    margin-top: 10px;
    margin-bottom: 10px;
}
.product-sku{
    display: flex;
    gap: 30px;
    font-size: 1.18rem;
    font-weight: 400;
    color: var(--black);
}

.product-availability-container{
    // margin-top: -12px;
}

.availability-status {
	width: 90px;
	height: 90px;
	border: 1px solid #283533;
	background: #283533;
	border-radius: 50%;
	position: relative;
	font-size: 0.75rem;
	font-weight: 300;
	text-align: center;
	color: #ffffff;
    display: flex;
    align-items: center;
    padding: 12px;
    box-sizing: border-box;
}

.availability-status.black {
	border: 1px solid #283533;
	background: #283533;
}

.availability-status.red {
	border: 1px solid #880D27;
	background: #880D27;
}

.availability-status.green {
	border: 1px solid #134A2C;
	background: #134A2C;
}

.availability-days {
	font-weight: 600;
}

.status-text{
    width: 100%;
}

.splodge-container{
    display: flex;
    gap: 12px;
}

.online-only-text{
    font-size: 0.95rem;
    margin-top: 12px;
}

</style>